import React from "react";

import Stack from "@mui/material/Stack";

import IbanMobileContent from "components/IbanInvoiceInfo/MobileContent";
import IbanDesktopContent from "components/IbanInvoiceInfo/DesktopContent";

import PageHeading from "components/IbanInvoiceInfo/PageHeading";
import BottomBanner from "components/IbanInvoiceInfo/BottomBanner";

import { IbanInvoiceResponseDto } from "api";

import { Bank } from "shared/constants/banks";
import { FormValues } from "components/IbanInvoiceInfo/IbanPaymentForm/validation";

interface IbanInfoDisplayProps {
  iban: IbanInvoiceResponseDto | null;
  isMobile: boolean;
  preferredBank?: string;
  paymentUrl?: string;
  handlePayment?: (values?: FormValues, bank?: Bank) => Promise<void>;
}

const IbanInfoDisplay: React.FC<IbanInfoDisplayProps> = (props) => {
  const { iban, preferredBank, isMobile, paymentUrl, handlePayment } = props;

  return isMobile ? (
    <IbanMobileContent
      iban={iban}
      preferredBank={preferredBank}
      handlePayment={handlePayment}
    />
  ) : (
    <>
      <PageHeading />
      <Stack direction="row" sx={{ alignItems: "flex-start", gap: 2 }}>
        <IbanDesktopContent
          iban={iban}
          paymentUrl={paymentUrl}
          handlePayment={handlePayment}
        />
      </Stack>
      <BottomBanner />
    </>
  );
};

export default IbanInfoDisplay;
